import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { useGetUserQuery, useResetUserPasswordMutation } from '../../api/peopleApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import buttons from '../../styles/shared/buttons.module.css';

export default function UserPasswordPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const showToast = useToast();

  const { data: user, isLoading } = useGetUserQuery(id);
  const [resetPassword, { isLoading: isResetting }] = useResetUserPasswordMutation();

  const { control, handleSubmit } = useForm({ defaultValues: { password: '' } });

  const onSubmit = async (data) => {
    try {
      await resetPassword({ id, password: data.password.trim() }).unwrap();
      showToast('success', 'Users', 'Password reset.');
      navigate('/admin/users');
    } catch (err) {
      showToast('error', 'Users', errMsg(err, 'Could not reset password.'));
    }
  };

  if (isLoading) return <p className="textMuted">Loading…</p>;

  return (
    <EntityFormPage title="Reset password" backTo="/admin/users">
      <form onSubmit={handleSubmit(onSubmit)}>
        {user && (
          <p className="textMuted mb-3">
            New password for <strong>{user.name}</strong> ({user.email}).
          </p>
        )}
        <Controller
          name="password"
          control={control}
          rules={{ required: true, minLength: 8 }}
          render={({ field, fieldState }) => (
            <div className="field">
              <label htmlFor={field.name}>New password (min 8 chars)</label>
              <Password
                inputId={field.name}
                className={`w-full ${fieldState.invalid ? 'p-invalid' : ''}`}
                inputClassName="w-full"
                toggleMask
                feedback={false}
                {...field}
              />
            </div>
          )}
        />
        <Button
          type="submit"
          label="Reset password"
          className={buttons.saveBtn}
          loading={isResetting}
        />
      </form>
    </EntityFormPage>
  );
}
